import React from 'react';
import { Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import EpisodeMarquee from './EpisodeMarquee';
import episodesData from '../data/episodes.json';
import { normalizeEpisode } from '../utils/format';

const LATEST = episodesData.seasons
  .flatMap(season => season.episodes)
  .sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate))
  .slice(0, 10)
  .map(ep => ({ ...normalizeEpisode(ep), duration: ep.duration }));

const ViewAllLink = (
  <RouterLink to="/episodes">
    <Text
      fontSize={{ base: "xs", md: "sm" }}
      color="brand.400"
      _hover={{ color: 'brand.300' }}
      transition="color 0.15s"
      fontWeight="medium"
    >
      View all →
    </Text>
  </RouterLink>
);

const LatestEpisodes = () => (
  <EpisodeMarquee
    heading="Latest Episodes"
    headingRight={ViewAllLink}
    episodes={LATEST}
    trackName="latest"
    speedSec={40}
    mobileSpeedSec={32}
  />
);

export default LatestEpisodes;
